import { APP_API_URL, APP_API_URL_V2 } from '../../utils/xhr-instance';
import { CREATE_PURCHASE_ORDER } from '../../store/action/purchaseOrder';
import axiosInstance, { axiosInstanceV2 } from '../axios';

export const fetchPurchaseOrders = async (params) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.get(`${APP_API_URL}/purchase-order/get-purchase-order`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
};

export const getPurchaseOrders = async (params) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/purchase/orders/list`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
};

export const getPurchaseOrderDetails = async (id) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/purchase/orders/details/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
};

export const deletePurchaseOrder = async (id) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.delete(
			`${APP_API_URL}/purchase-order/delete-purchaseorder/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
};

export async function fetchPurchaseOrderNumber() {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.get(
			`${APP_API_URL}/purchase-order/get-purchase-order-number`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data?.purchase_order_number;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function getDeliveryMethod(params) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.get(`${APP_API_URL}/purchase-order/get-delivery-method`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data?.delivery_methods;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function addDeliveryMethod(body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(
			`${APP_API_URL}/purchase-order/create-delivery-method`,
			body,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data?.delivery_method;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function create_purchase_order(body) {
	try {
		let API_URL = CREATE_PURCHASE_ORDER;
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(API_URL, body, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});

		if (data.code === 422) {
			throw new Error(data.message[0].message);
		}
		if (data.code === 400) {
			throw new Error(data.message[0].message);
		}
		if (!data) {
			throw new Error(data.message[0].message);
		}
		return data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function update_purchase_order(id, body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.put(
			`${APP_API_URL}/purchase-order/update-purchase-order/${id}`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);

		if (data.code === 422) {
			throw new Error(data.message[0].message);
		}
		return data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function update_purchase_order_status(id, body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.put(
			`${APP_API_URL}/purchase-order/update-purchaseorder-status/${id}`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function discard_purchase_order_product_quantity(body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(
			`${APP_API_URL}/purchase-order//discard-purchase-order-product-quantity`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function update_bulk_purchase_order_status(body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.put(
			`${APP_API_URL}/purchase-order/bulkupdate-purchaseorder-status`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data;
	} catch (error) {
		throw new Error(error.response.data.message);
	}
}

export async function sendEmail(body) {
	const token = localStorage.getItem('authToken');
	const { data } = await axiosInstance.post(`${APP_API_URL}/purchase-order/send-email`, body, {
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	});
	return data;
}

export async function exportPurchaseOrderData(params) {
	const token = localStorage.getItem('authToken');

	const response = await axiosInstance.get(`${APP_API_URL}/purchase-order/export-table`, {
		params,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		responseType: 'blob',
	});

	const blob = new Blob([response.data], {
		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	});
	const url = window.URL.createObjectURL(blob);

	const a = document.createElement('a');
	a.href = url;
	a.download = `purchase_table.xlsx`;
	document.body.appendChild(a);
	a.click();

	a.remove();
	window.URL.revokeObjectURL(url);
}

export async function generatePurchaseOrderPdf(id, merge = false) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/purchase/orders/generate-pdf?ids=${id}&merge=${merge}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data?.data.signed_urls[0];
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}
